import { z } from 'zod';

export const CONTACT_TOPICS = ['Account or membership', 'Hosting a league', 'Playing in a league', 'Something else'] as const;
/** Limits apply to both the public form and API. Message bodies may contain line breaks. */
export const CONTACT_LIMITS = { name: 100, email: 254, message: 5000 } as const;
const header = (label: string, max: number) => z.string({ required_error: `${label} is required.` }).regex(/^[^\r\n]*$/, `${label} must be on one line.`).trim().min(1, `${label} is required.`).max(max, `${label} must be ${max} characters or fewer.`);
export const contactSchema = z.object({
  name: header('Name', CONTACT_LIMITS.name),
  email: header('Email', CONTACT_LIMITS.email).email('Enter a valid email address.'),
  topic: z.string({ required_error: 'Choose a topic.' }).trim().pipe(z.enum(CONTACT_TOPICS, { errorMap: () => ({ message: 'Choose a topic.' }) })),
  message: z.string({ required_error: 'Your message is required.' }).trim().min(1, 'Your message is required.').max(CONTACT_LIMITS.message, 'Your message must be 5000 characters or fewer.'),
  website: z.string().max(0, 'Please leave the website field empty.').optional(),
});
export type ContactInput = z.infer<typeof contactSchema>;
